import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Rating } from "@mui/material";
import { ENV } from "../../util/Env";
import Loader from "../../util/preloader/Preloader";
import DspFooter from "../events/DspFooter";
import DspHeader from "../events/DspHeader";
import NotificationModal from "../events/NotificationModal";

const SessionFeedback = () => {
  // Previous routing was /Feedback/:Uid/:Sid/:Kid
  const { Uid: routeUid } = useParams();
  // const { Kid } = useParams();
  const { Sid } = useParams();
  const [Uid, setUid] = useState(routeUid || null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [authStr, setAuthStr] = useState("");
  const [data, setData] = useState([]);
  const [userfeedbackSubmit, setUserfeedbackSubmit] = useState(false);
  const [ratings, setRatings] = useState({}); // Store ratings for each question

  const [feedback, setFeedback] = useState("");
  const maxChars = 500;

  // Identity verification (email / mobile) gating the rest of the form
  const [verifyEmail, setVerifyEmail] = useState("");
  const [verifyMobile, setVerifyMobile] = useState("");
  const [isVerified, setIsVerified] = useState(true);
  const [verifyError, setVerifyError] = useState("");

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("feedback"); // 'feedback', 'success', 'error'
  const [modalMessage, setModalMessage] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalAction, setModalAction] = useState(null);

  const [uspTemData, setuspTemData] = useState([]);
  useEffect(() => {
    // fetchFeedback() needs the Uid, so it now runs after verification instead.
    // The question list doesn't depend on the user, so it can load up front.
    // fetchFeedback();
    fetchData();
    fetchSingleEvent();
  }, [authStr]);

  const fetchSingleEvent = async () => {
    const url = ENV.API_URL + `web/api/v1/lms-web/website/getEvent/${Sid}`;
    const token = authStr;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: ``,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const results = await response.json();

      setuspTemData(results);
    } catch (error) {
      setModalType("error");
      setModalTitle("Error Loading Event");
      setModalMessage(
        "We are temporarily experiencing technical difficulties. Please try again after sometime",
      );
      setModalAction(() => () => {
        setShowModal(false);
        navigate(`/`);
      });
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  // Unused, and depended on the :Kid route param that no longer exists
  // const fetchAllFeedToken = async () => {
  //   const url = ENV.API_URL + `user/api/v1/lms-user/getOneTimeToken/${Kid}`;
  //   const token = authStr;
  //
  //   try {
  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         Authorization: ``,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  //     const results = await response.text();
  //
  //     localStorage.setItem("user", results);
  //     fetchFeedback(results);
  //
  //     setAuthStr(results);
  //   } catch (error) {
  //     // setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // userId is passed in rather than read from state, since it is resolved by
  // the verification call in the same tick and state wouldn't be updated yet
  const fetchFeedback = async (userId) => {
    const url =
      ENV.API_URL +
      `admin/api/v1/lms-admin/feedback/getFeedbackStatus/${userId}/${Sid}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("result", result);
      if (result.avgScore == null) {
        // fetchData(result); // question list is now loaded on mount instead
        setUserfeedbackSubmit(false);
      } else {
        setUserfeedbackSubmit(true);
      }
    } catch (error) {
      // setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (x) => {
    const url = ENV.API_URL + `admin/api/v1/lms-admin/feedback/getQuestionList`;
    const token = x;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setData(result);
    } catch (error) {
      // setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRatingChange = (questionId, newRating) => {
    setRatings((prevRatings) => ({
      ...prevRatings,
      [questionId]: newRating,
    }));
  };

  const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const MOBILE_PATTERN = /^[6-9]\d{9}$/;

  // The value of the most recent lookup, so that a response arriving after the
  // user has edited the field again can be discarded
  const latestVerifyRef = useRef("");

  /*
  // Checks whether the entered email/mobile belongs to a student registered
  // for this session
  const checkUserPresence = async (identifier) => {
    latestVerifyRef.current = identifier;
    setVerifyError("");

    const isEmail = EMAIL_PATTERN.test(identifier);

    try {
      const url =
        ENV.API_URL +
        `web/api/v1/lms-web/admin/session/validate-student-session`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // Sid comes off the URL as a string, but the API expects a number
          sessionId: Number(Sid),
          email: isEmail ? identifier : null,
          mobile: isEmail ? null : identifier,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (latestVerifyRef.current !== identifier) return;

      if (result && result.present === true) {
        setUid(result.id);
        setIsVerified(true);
        fetchFeedback(result.id);
      } else {
        setModalType("error");
        setModalTitle("Verification Failed");
        setModalMessage(
          (result && result.message) ||
            "We are temporarily experiencing technical difficulties. Please try again after sometime",
        );
        setShowModal(true);
      }
    } catch (error) {
      if (latestVerifyRef.current !== identifier) return;

      setModalType("error");
      setModalTitle("Verification Failed");
      setModalMessage(
        "We are temporarily experiencing technical difficulties. Please try again after sometime",
      );
      setShowModal(true);
    }
  };
  */

  // Editing either field invalidates a previous verification, re-locking the
  // form until the new value has been checked
  const handleVerifyEmailChange = (value) => {
    setVerifyEmail(value);
    setVerifyError("");
    setIsVerified(false);
    setUid(null);
  };

  const handleVerifyMobileChange = (value) => {
    setVerifyMobile(value.replace(/\D/g, "").slice(0, 10));
    setVerifyError("");
    setIsVerified(false);
    setUid(null);
  };

  // Whichever field currently holds a complete, valid value ("" if neither does)
  const email = verifyEmail.trim();
  const mobile = verifyMobile.trim();
  const verifyIdentifier =
    (EMAIL_PATTERN.test(email) && email) ||
    (MOBILE_PATTERN.test(mobile) && mobile) ||
    "";

  /*
  // Verify as soon as a complete value is typed, without waiting for blur.
  // Re-runs whenever the value changes, so an edit triggers a fresh lookup.
  useEffect(() => {
    if (!verifyIdentifier) return undefined;

    const timer = setTimeout(() => checkUserPresence(verifyIdentifier), 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyIdentifier]);

  // A complete value is already handled above, so on blur only an
  // incomplete entry is worth flagging
  const handleVerifyBlur = () => {
    if (verifyIdentifier) return;
    if (email) {
      setVerifyError("Please enter a valid email address.");
    } else if (mobile) {
      setVerifyError(
        "Please enter a valid 10-digit mobile number starting with 6-9.",
      );
    }
  };
  */

  const feedbackSubmission = async () => {
    if (!email && !mobile) {
      setModalType("error");
      setModalTitle("Email or Mobile Required");
      setModalMessage("Please enter either an email address or mobile number.");
      setModalAction(() => () => setShowModal(false));
      setShowModal(true);
      return;
    }

    const url = ENV.API_URL + `admin/api/v1/lms-admin/feedback/submit`;
    const token = authStr;

    // Convert ratings object to array format expected by API
    const ratingsData = Object.keys(ratings).map((questionId) => ({
      questionId: questionId,
      // Safely cast to a Number, multiply by 2, then convert back to a string
      answerPoint: (Number(ratings[questionId]) * 2).toString(),
      answerValue: `${ratings[questionId]} stars`,
    }));

    const payload = {
      sessionId: Sid,
      userId: Uid,
      email: email || null,
      mobileNo: mobile || null,
      data: ratingsData,
      userFeedback: feedback,
    };

    setLoading(true);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("user")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setModalType("success");
      setModalTitle("Feedback Successfully Submitted");
      setModalMessage(" ");
      setModalAction(() => () => {
        localStorage.removeItem("user");
        setShowModal(false);
        navigate(`/`);
      });
      setShowModal(true);
    } catch (error) {
      setModalType("error");
      setModalTitle("Error Submitting Feedback");
      setModalMessage(
        !error.data
          ? "We are temporarily experiencing technical difficulties. Please try again after sometime"
          : error.data,
      );
      setModalAction(() => () => setShowModal(false));
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTextAreaValue = (value) => {
    if (value.length <= maxChars) {
      setFeedback(value);
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* main page  */}
          <div className="usp_main Feedbackbg">
            {/* Top Navigation Header */}
            <DspHeader />
            <div className="container-lg ">
              <div className="row justify-content-center py-5">
                <div className="d-flex justify-content-center Feedbackbg5">
                  {!userfeedbackSubmit ? (
                    <div className="feedback-main">
                      <div className="feedback-verify-section">
                        <div className="feedback-verify-row">
                          <div className="feedback-verify-field">
                            <label
                              className="feedback-label"
                              htmlFor="verifyEmail"
                            >
                              Enter Email
                            </label>
                            {/* onBlur={handleVerifyBlur} */}
                            <input
                              id="verifyEmail"
                              type="email"
                              className="form-control feedback-verify-input"
                              placeholder="name@domain.com"
                              value={verifyEmail}
                              disabled={!!mobile}
                              onChange={(e) =>
                                handleVerifyEmailChange(e.target.value)
                              }
                            />
                          </div>
                          <span className="feedback-verify-divider">OR</span>
                          <div className="feedback-verify-field">
                            <label
                              className="feedback-label"
                              htmlFor="verifyMobile"
                            >
                              Enter Mobile No
                            </label>
                            {/* onBlur={handleVerifyBlur} */}
                            <input
                              id="verifyMobile"
                              type="tel"
                              maxLength={10}
                              className="form-control feedback-verify-input"
                              placeholder="99999 99999"
                              value={verifyMobile}
                              disabled={!!email}
                              onChange={(e) =>
                                handleVerifyMobileChange(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        {/* {verifyError && (
                          <div className="feedback-verify-error">
                            {verifyError}
                          </div>
                        )} */}
                        {/* {isVerified && (
                          <div className="feedback-verify-success">
                            Verified! You can now submit your feedback below.
                          </div>
                        )} */}
                      </div>

                      <h2 className="feedback-title">Event Feedback</h2>
                      {/* disabled={!isVerified} */}
                      <fieldset
                        className="feedback-fieldset"
                      >
                        {data.map((item, index) => {
                          return (
                            <div
                              key={item.id}
                              className="feedback-question-item"
                            >
                              <div className="feedback-question-text">
                                <span className="question-number">
                                  {index + 1}.
                                </span>{" "}
                                {item.question}
                              </div>
                              <div className="feedback-stars">
                                <Rating
                                  value={ratings[item.id] || 0}
                                  onChange={(event, newValue) =>
                                    handleRatingChange(item.id, newValue)
                                  }
                                  size="medium"
                                  sx={{
                                    "& .MuiRating-iconFilled": {
                                      color: "#EFC100 !important",
                                    },
                                    "& .MuiRating-iconHover": {
                                      color: "#FFF3B3 !important",
                                    },
                                    "& .MuiRating-icon": {
                                      fontSize: "24px",
                                      color: "#555555",
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })}

                        <div className="feedback_textarea">
                          <label className="feedback-label">Remark</label>
                          <textarea
                            className="form-control feedback-textarea-input"
                            rows="4"
                            placeholder="Please provide additional feedback here"
                            name="userFeedback"
                            maxLength={maxChars}
                            value={feedback}
                            onChange={(e) =>
                              handleTextAreaValue(e.target.value)
                            }
                          ></textarea>
                        </div>

                        <div className="submit-btn">
                          <button
                            type="button"
                            className="feedback-submit-btn"
                            onClick={() => feedbackSubmission()}
                          >
                            Submit
                          </button>
                        </div>
                      </fieldset>
                    </div>
                  ) : (
                    <div className="content">
                      <div className="wrapper-1">
                        <div className="wrapper-2">
                          <h1>Thank you for your feedback!</h1>
                          <p>
                            We appreciate your input and want to let you know
                            that your feedback has already been recorded
                          </p>
                          <p> Have a great day.</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Footer */}
            <DspFooter />
          </div>
        </>
      )}

      {/* Notification Modal */}
      <NotificationModal
        isOpen={showModal}
        type={modalType}
        message={modalMessage}
        title={modalTitle}
        onClose={() => {
          if (modalAction) {
            modalAction();
            setModalAction(null);
          } else {
            setShowModal(false);
          }
          setModalMessage("");
          setModalTitle("");
        }}
      />
    </React.Fragment>
  );
};

export default SessionFeedback;
